/*
    Pagination for list of PDF with download links.
    Pagination will be added to all elements with .pdf-download-list class
    when number of elements in container is greater than 10.

    This script add Show all button as well. It will appear when number of elements
    is greater than 4. onClick it shows elements 4-10 and initialize pagination.
 */

const elementsPerPage = 10;
const maxInitItemsForShowMoreBtn = 4;
let currentPage = 1;

/*
    Main function which handles Show all button logic with pagination initialization or destroy.
 */
window.addEventListener('DOMContentLoaded', () => {
    const downloadBtnsContainers = document.querySelectorAll('.bsct-buttons-download:not(.bsct-search-result)');
    downloadBtnsContainers.forEach(item => {
        const pdfListID = `#${item.id}`;

        let downloadBtnsList = document.querySelectorAll(`${pdfListID} .col`);
        const showAllBtn = document.querySelector(`${pdfListID} .show-all-downloads-btn`);
        const downloadAllBtn = document.querySelector(`${pdfListID} .download-all-btn`);

        downloadAllBtn?.addEventListener('click', () => {
            downloadAll(downloadBtnsList);
        });

        if (!showAllBtn) return;

        if (downloadBtnsList.length > maxInitItemsForShowMoreBtn) {
            let itemsToHide = [...downloadBtnsList].filter((_, idx) => idx + 1 > maxInitItemsForShowMoreBtn);
            itemsToHide.forEach(item => item.classList.add('hidden'));

            showAllBtn.classList.add('enable');
            showAllBtn.addEventListener('click', (e) => {
                showAllBtn.classList.toggle('all-visible');

                if (e.target.classList.contains('all-visible')) {
                    e.target.textContent = 'Ukryj';

                    if (downloadBtnsList.length > elementsPerPage) {
                        initPagination(pdfListID);
                    } else {
                        updateVisibleElements(document.querySelector(`${pdfListID}`), 1);
                    }

                    containerTopScroll(document.querySelector(`${pdfListID}`));
                } else {
                    e.target.textContent = 'Pokaż wszystkie';

                    updateVisibleElements(document.querySelector(`${pdfListID}`));
                    containerTopScroll(document.querySelector(`${pdfListID}`));

                    if (downloadBtnsList.length > elementsPerPage) {
                        destroyPagination(pdfListID);
                    }
                }
            })
        }
    })
})

/*
   Initialize pagination with default state.
 */
const initPagination = (pdfListID) => {
    const item = document.querySelector(`${pdfListID}`);
    const downloadBtnsList = item.querySelectorAll('.col');
    const pageCount = Math.ceil(downloadBtnsList.length / elementsPerPage);
    const navContainer = item.querySelector('.navigation');

    getPaginationContainers(navContainer);

    const paginationNumbers = item.querySelector('.pagination-numbers');
    const paginationPrev = item.querySelector('.pagination-button-prev');
    const paginationNext = item.querySelector('.pagination-button-next');

    paginationNumbers.setAttribute('data-page-count', pageCount);

    getPaginationNumbers(pageCount, paginationNumbers);
    setCurrentPage(1, item);

    paginationPrev.addEventListener("click", () => {
        setCurrentPage(currentPage - 1, item);
    });

    paginationNext.addEventListener("click", () => {
        setCurrentPage(currentPage + 1, item);
    });

    item.querySelectorAll(".pagination-number").forEach((button) => {
        const pageIndex = Number(button.getAttribute("page-index"));

        if (pageIndex) {
            button.addEventListener("click", () => {
                setCurrentPage(pageIndex, item);
            });
        }
    });
}

/*
    Remove pagination from DOM with all event listeners.
 */
const destroyPagination = (pdfListID) => {
    const item = document.querySelector(`${pdfListID}`);
    const navContainer = item.querySelector('.pagination-container');

    navContainer.remove();
}

/*
    Create core pagination elements in passed container.
 */
const getPaginationContainers = (container) => {
    const paginationContainerInner = `
        <button class='pagination-button-prev' id='prev-button' aria-label='Poprzednia strona'></button>
        <div class='pagination-numbers'></div>
        <button class='pagination-button-next' id='next-button' aria-label='Następna strona'></button>`

    const paginationContainer = document.createElement('div');
    paginationContainer.className = "pagination-container";
    paginationContainer.innerHTML = paginationContainerInner;

    container.insertBefore(paginationContainer, container.firstChild);
}

/*
    Create single pagination number.
 */
const appendPageNumber = (index, paginationNumbers) => {
    const pageNumber = document.createElement("button");
    pageNumber.className = "pagination-number";
    pageNumber.innerHTML = index;
    pageNumber.setAttribute("page-index", index);
    pageNumber.setAttribute("aria-label", "Page " + index);

    paginationNumbers.appendChild(pageNumber);
};

/*
    Create all pagination number elements.
 */
const getPaginationNumbers = (pageCount, paginationNumbers) => {
    paginationNumbers.innerHTML = '';
    for (let i = 1; i <= pageCount; i++) {
        appendPageNumber(i, paginationNumbers);
    }
};

/*
    Update all pagination buttons states according to passed page number.
 */
const setCurrentPage = (pageNum, item) => {
    currentPage = pageNum;

    handleActivePageNumber(item);
    handlePageButtonsStatus(item);

    updateVisibleElements(item, pageNum);
    containerTopScroll(item);
};

/*
    Show and hide elements of list according to passed page number.
 */
const updateVisibleElements = (item, pageNum) => {
    pageNum = pageNum || false;

    let prevRange = 0;
    let currRange = maxInitItemsForShowMoreBtn;

    if (pageNum) {
        prevRange = (pageNum - 1) * elementsPerPage;
        currRange = pageNum * elementsPerPage;
    }

    item.querySelectorAll('.col').forEach((item, index) => {
        item.classList.add("hidden");
        if (index >= prevRange && index < currRange) {
            item.classList.remove("hidden");
        }
    });
}

/*
    Add active class for current page number.
 */
const handleActivePageNumber = (item) => {
    item.querySelectorAll(".pagination-number").forEach((button) => {
        button.classList.remove("active");
        const pageIndex = Number(button.getAttribute("page-index"));
        if (pageIndex === currentPage) {
            button.classList.add("active");
        }
    });
};

/*
    Disable next/previous page button.
 */
const disableButton = (button) => {
    button.classList.add("disabled");
    button.setAttribute("disabled", '');
};

/*
    Enable next/previous page button.
 */
const enableButton = (button) => {
    button.classList.remove("disabled");
    button.removeAttribute("disabled");
};

/*
    Enable or disable next/prev pagination buttons.
 */
const handlePageButtonsStatus = (item) => {
    const paginationPrev = item.querySelector('.pagination-button-prev');
    const paginationNext = item.querySelector('.pagination-button-next');

    if (currentPage === 1) {
        disableButton(paginationPrev);
    } else {
        enableButton(paginationPrev);
    }

    if (parseInt(item.querySelector('.pagination-numbers').getAttribute('data-page-count')) === currentPage) {
        disableButton(paginationNext);
    } else {
        enableButton(paginationNext);
    }
};

/*
    Triggers scroll to the top of passed container.
 */
const containerTopScroll = (container) => {
    container.scrollIntoView({behavior: "smooth", block: "start"});
}

/*
    Trigger download all attachments.
 */
const downloadAll = (downloadBtnsList) => {
    downloadBtnsList.forEach(item => {
        item.querySelector('a').click();
    });
}